import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  drawer: {
    width: 320
    // flexShrink: 0
    // overflow: 'hidden'
  },
  drawerPaper: {
    width: 320,
    display: 'flex',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    overflow: 'hidden'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    // height: '100%',
    width: '100%'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '8px 12px',
    borderRadius: 0,
    borderBottom:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`
  },
  scrollableContent: {
    flex: 1,
    overflowY: 'auto',
    ...theme.scrollbarStyles
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    '& button': {
      padding: '0 !important',
      backgroundColor: 'transparent'
    },
    '& button:hover': {
      backgroundColor: 'transparent'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& svg:hover': {
      color: theme.palette.blue_300.main
    }
  },
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    margin: '0'
  },
  timelineTitle: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '1.1rem',
    textAlign: 'center',
    fontWeight: 'bold',
    margin: '2px 0 10px 0'
  },
  timelineItem: {
    '&:before': {
      flex: 0,
      padding: 0
    },
    '& .MuiTimelineContent-root': {
      padding: '0 8px !important'
    }
  },
  timelinePaper: {
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    padding: '8px',
    borderRadius: '8px'
  },
  timelineContentDate: {
    display: 'flex',
    // alignItems: 'center',
    gap: '8px',
    fontSize: '0.8rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  timelineContentTitle: {
    fontSize: '1rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  timelineContentUser: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  botDot: {
    '& .MuiTimelineDot-root': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  },
  transferDot: {
    '& .MuiTimelineDot-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.gray_300.main,
      boxShadow: 'none',
      '& svg': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.white_100.main
      }
    }
  },
  // historyDot: {
  //   color:
  //     theme.palette.type === 'dark'
  //       ? theme.palette.dark_600.main
  //       : theme.palette.gray_300.main,
  //   boxShadow: 'none',
  //   '& svg': {
  //     color:
  //       theme.palette.type === 'dark'
  //         ? theme.palette.dark_50.main
  //         : theme.palette.white_100.main
  //   }
  // },
  noteDot: {
    '& .MuiTimelineDot-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.gray_300.main,
      boxShadow: 'none',
      '& svg': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.white_100.main
      }
    }
  },
  closedDot: {
    '& .MuiTimelineDot-root': {
      backgroundColor: theme.palette.red_100.main,
      boxShadow: 'none'
    }
  },
  historyDot: {
    '& .MuiTimelineDot-root': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none',
      '& svg': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.white_100.main
      }
    }
  },
  manualDot: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    boxShadow: 'none !important',
    '& .MuiTimelineDot-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.gray_300.main,
      boxShadow: 'none !important',
      '& svg': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.white_100.main
      }
    }
  }
}))
